module.exports = __webpack_public_path__ + "static/media/icon-dev-1.51a43571.svg";